import { useMutation } from 'react-query';
import {useWordPressStore} from "../../store/wordpress.store";
import {WordpressApi} from "../../api/wordpress.api";

export const useWordPressSocials = () => {
    const setSocials = useWordPressStore((state) => state.setSocials);

    return useMutation(WordpressApi.getSocials, {
        onSuccess: (data) => {
            setSocials(data);
        },
        onError: (error) => {
            console.error('Login failed:', error);
        },
    });
};